export default __webpack_public_path__ + "static/media/aditya.7ed794e8.jpg";